import React from "react";

export function PageHeader({ eyebrow, title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        {eyebrow && (
          <span className="text-gold-dark text-xs tracking-[0.2em] uppercase font-bold">{eyebrow}</span>
        )}
        <h1 className="font-display text-3xl lg:text-4xl font-bold text-navy-900 tracking-tight mt-1">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function DemoBadge({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-bold tracking-wider uppercase px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 border border-amber-200 ${className}`}
      data-testid="demo-badge">
      Demo data
    </span>
  );
}
